import * as types from "../../actions/ActionTypes";

const initialState = {
  selectedPlan: null,
};

const selectedPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SELECTED_PLAN:
      return { ...state, selectedPlan: action.payload };
    case types.CLEAR_SELECTED_PLAN:
      return { ...state, selectedPlan: null };
    default:
      return state;
  }
};

export default selectedPlanReducer;
